import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EndPoints from "../../Api/Endpoints";

export const fetchReligionsData = createAsyncThunk(
  "api/fetchReligions",
  async () => {
    const token = localStorage.getItem("other");
    const response = await fetch(EndPoints.PRISM_GET_RELIGIONS, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  }
);

const religionSlice = createSlice({
  name: "religion",
  initialState: {
    religiondata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReligionsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReligionsData.fulfilled, (state, action) => {
        state.loading = false;
        state.religiondata = action.payload?.data || [];
      })
      .addCase(fetchReligionsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default religionSlice.reducer;